import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import VendorOverchargesChart from './VendorOverchargesChart';
import { fetchVendors } from 'redux/vendors/VendorsActions';

const mapStateToProps = ({ vendors }) => ({
  fetchingVendors: vendors.fetchingVendors,
  vendors: vendors.vendors ? vendors.vendors.filter(vendor => vendor.vendorTax !== null).slice(0, 10) : []
});

const mapDispatchToProps = dispatch => ({
  vendorsActions: bindActionCreators({ fetchVendors }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(VendorOverchargesChart);



// WEBPACK FOOTER //
// ./src/components/dashboard/comp/vendorOverchargesChart/VendorOverchargesChartConnector.js